import { render, staticRenderFns } from "./Observations.vue?vue&type=template&id=bedfea00&"
import script from "./Observations.vue?vue&type=script&lang=ts&"
export * from "./Observations.vue?vue&type=script&lang=ts&"
import style0 from "./Observations.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports